module.exports = __webpack_public_path__ + "img/MTW.a977d5b6.jpg";